import { render, staticRenderFns } from "./c_txt_tab.vue?vue&type=template&id=01122ede&scoped=true"
import script from "./c_txt_tab.vue?vue&type=script&lang=js"
export * from "./c_txt_tab.vue?vue&type=script&lang=js"
import style0 from "./c_txt_tab.vue?vue&type=style&index=0&id=01122ede&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01122ede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01122ede')) {
      api.createRecord('01122ede', component.options)
    } else {
      api.reload('01122ede', component.options)
    }
    module.hot.accept("./c_txt_tab.vue?vue&type=template&id=01122ede&scoped=true", function () {
      api.rerender('01122ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_txt_tab.vue"
export default component.exports